export default "__VITE_ASSET__86454e0b__$_?nuxt_component=async__"